// @flow

import React from 'react';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import type { ReconciliationStore } from '../../../../types/shoppingCenterType';
import RippleButton from '../../../../components/RippleButton';
import reconciliationApi from '../../../../network/api/reconciliationApi';
import { getCurrentPcId } from '../../../../utils/urlUtils';
import { reconciliationAction, reconciliationStates } from '../../../../const';
import IconButton from '../../../../components/IconButton';
import type { StoreGemini, VisioglobeUnitsMap } from '../../../../types/geminiType';
import { notifyApolloError } from '../../../../network/notification';

type Props = {
  dispatch: () => void,
  visioglobeUnitsMap: VisioglobeUnitsMap,
  updateVisioglobeUnits: Function,
  changeMappingMode: Function,
  selectedStore: ReconciliationStore,
}

type State = {
  messageMustBeDisplayed: boolean,
}

class EmptyUnitMapping extends React.Component<Props, State> {
  state = {
    messageMustBeDisplayed: false,
  };

  displayReconciliationPossibleStores = () => {
    const possibleStoreList = this.props.visioglobeUnitsMap.mercuryOnly;
    if (possibleStoreList.length === 0) {
      return (
        <p>
          {I18n.t('SIDE_DATA.EMPTY_UNIT.NO_STORES')}
        </p>
      );
    }
    return possibleStoreList.sort((a, b) =>
      a.storeName.localeCompare(b.storeName))
      .sort((a, b) =>
        moment(a.closingDate) - (moment(b.closingDate)))
      .map((store: StoreGemini) => (
        <RippleButton
          key={store.reconciliationId}
          className={`mercury-only-store${moment(store.closingDate).isBefore(moment()) ? ' mercury-only-store--impossible' : ''}`}
          onClick={() => {
            this.saveStoreMapping(
              store,
              this.props.selectedStore.idStoreCms,
              this.props.selectedStore.idVisioglobes,
              reconciliationAction.MAPPED,
            );
          }}
        >
          <span>
            {
              I18n.t('MAPPING_MODE.name', {
                mercuryName: store.storeName,
                retailerName: store.retailerName,
              })
            }
          </span>
          {
            store.retailerId
            && (
              <span>{I18n.t('MAPPING_MODE.idMercury', { idMercury: store.codstr })}</span>
            )
          }
          {
            store.gla
            && (
              <span>{I18n.t('MAPPING_MODE.gla', { gla: store.gla })}</span>
            )
          }
          {
            store.openDate
            && (
              <span>{I18n.t('MAPPING_MODE.openingDate', { openingDate: store.openDate })}</span>
            )
          }
        </RippleButton>
      ));
  };

  isEmptyUnit = () => (reconciliationStates.EMPTY_UNIT === this.props.selectedStore.state
    || reconciliationStates.HISTORY === this.props.selectedStore.state);

  saveStoreMapping = (
    storeGemini: StoreGemini,
    idStoreCms ?: string,
    idVisioglobes ?: string[],
    type: string,
  ) => {
    const reconciliationStoreMappingBean =
      {
        idReconciliation: storeGemini.reconciliationId,
        idStoreCms,
        idMercury: storeGemini.codstr,
        idVisioglobes,
      };

    reconciliationApi.saveStoreMapping(getCurrentPcId(), type, reconciliationStoreMappingBean)
      .then(this.props.updateVisioglobeUnits)
      .catch(e => this.props.dispatch(notifyApolloError(e)));
  };

  render() {
    if (!this.props.selectedStore) {
      return false;
    }
    return (
      <>
        <div className="btn-apollo-container">
          <RippleButton
            className="apollo-button-contained rounded-button"
            onClick={() => {
              this.setState({
                messageMustBeDisplayed: !this.state.messageMustBeDisplayed,
              });
            }}
            disabled={!this.isEmptyUnit()}
          >
            <i className="fas fa-medal" />
            <span>{I18n.t('SIDE_DATA.apollo')}</span>
          </RippleButton>
        </div>
        {
          !this.isEmptyUnit()
            ? (
              <div className="data-mapping-mode">
                <div className="content-data-mapping-mode">
                  <div className="action-mapping-mode">
                    <p>
                      {I18n.t('SIDE_DATA.EMPTY_UNIT.MUST_BE_MAPPED_WITH_MAPPING_MODE')}
                    </p>
                    <IconButton
                      icon="fas fa-repeat-alt"
                      className="expand-button"
                      onClick={() =>
                        this.props.changeMappingMode(this.props.selectedStore)
                      }
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="data-mapping-mode">
                <div className="content-data-mapping-mode">
                  <div className="action-mapping-mode empty-units-mapping-mode">
                    {
                      this.state.messageMustBeDisplayed && (
                        <p>{I18n.t('SIDE_DATA.EMPTY_UNIT.MUST_BE_MAPPED')}</p>
                      )
                    }
                    <p>{I18n.t('SIDE_DATA.EMPTY_UNIT.CHOOSE')}</p>
                    <small>{I18n.t('SIDE_DATA.EMPTY_UNIT.STORES_RED')}</small>
                    <div className="mercury-only">
                      {this.displayReconciliationPossibleStores()}
                    </div>
                  </div>
                </div>
              </div>
            )
        }
      </>
    );
  }
}

export default (EmptyUnitMapping);
